import moment from 'moment';

class Util {

    public validCPF = (value: string) => {
        const cpf = value.replace(/[\D]/g, '');
        if (cpf.length !== 11 || /^([0-9])\1*$/.test(cpf)) {
            return false;
        }
        else {
            const digits = cpf.substring(9);
            const first = this.validCPFGetFirstDigit(cpf);
            const second = this.validCPFGetSecondDigit(cpf);
            const er = first + '' + second + '';
            return digits === er;
        }
    }

    public validBirthDayElder = (value: string, minAge: number, inFormat?: string) => {
        const momentBirthDay = moment(value, inFormat);
        const momentNow = moment();

        const diff = momentNow.diff(momentBirthDay);
        const duration = moment.duration(diff);

        return duration.asYears() > minAge;
    }

    private validCPFGetFirstDigit = (value: string) => {
        let mult = 10, sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += mult * parseInt(value.charAt(i) + '');
            mult--;
        }
        let rest = 11 - sum % 11;
        if (rest >= 10) rest = 0;
        return rest;
    }

    private validCPFGetSecondDigit = (value: string) => {
        let mult = 11, sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += mult * parseInt(value.charAt(i) + '');
            mult--;
        }
        let rest = 11 - sum % 11;
        if (rest >= 10) rest = 0;
        return rest;
    }

    public validTime = (value: string) => {
         return (/([01]\d|2[0-3]):([0-5]\d)/).test(value);
    }



}

export const ValidationUtil = new Util();